<template>
  <div class="NewsPage Pt75">
    <div class="box">
      <div class="PubTitle center">
        <h2>新闻动态</h2>
        <p>洞察行业前沿，分享湿度知识，了解我们最新的企业与品牌动向</p>
      </div>

      <div class="news-tabs-container">
        <ul class="news-tabs">
          <li
              v-for="category in newsCategories"
              :key="category.id"
              :class="{ active: activeCategory && activeCategory.id === category.id }"
              @click="selectCategory(category)"
          >
            {{ category.name }}
          </li>
        </ul>
      </div>

      <div class="page-container">
        <main class="main-content">
          <div class="article-list">
            <div v-for="article in allArticles" :key="article.id" class="article-item clickable" @click="openArticleModal(article)">
              <div class="article-date">
                <span class="date-month">{{ formatDate(article.date).month }}</span>
                <span class="date-divider"></span>
                <span class="date-year">{{ formatDate(article.date).year }}</span>
              </div>
              <div class="article-content">
                <h3 class="article-title">{{ article.title }}</h3>
                <p class="article-excerpt">{{ article.excerpt }}</p>
                <div class="article-meta">
                  <span>发布于 {{ formatDate(article.date).fullDate }}</span>
                </div>
              </div>
            </div>
            <div v-if="allArticles.length === 0" class="no-articles-found">
              <p>该分类下暂无文章</p>
            </div>
          </div>
        </main>

        
      </div>
    </div>

    <ArticleDetailModal
        v-if="selectedArticle"
        :show="isModalVisible"
        :article="selectedArticle"
        @close="closeArticleModal"
    />
  </div>
</template>

<script>
import ArticleDetailModal from '@/components/ArticleDetailModal.vue';
import { getNewsCategory, getNewsArticle } from '@/api/request';

export default {
  name: 'NewsPage',
  components: {
    ArticleDetailModal,
  },
  data() {
    return {
      isModalVisible: false,
      selectedArticle: null,
      activeCategory: null,
      
      newsCategories: [],
      allArticles: [],
      
    };
  },
  methods: {
    openArticleModal(article) {
      this.selectedArticle = article;
      this.isModalVisible = true;
    },
    closeArticleModal() {
      this.isModalVisible = false;
      setTimeout(() => {
        this.selectedArticle = null;
      }, 300);
    },
    selectCategory(category) {
      this.activeCategory = category;
      this.fetchNewsArticles();
    },
    
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return {
        day: day,
        month: month,
        year: String(year),
        monthYear: `${year} / ${month}`,
        fullDate: `${year}-${month}-${day}`,
      };
    },
    
    async fetchNewsCategories() {
      try {
        const response = await getNewsCategory();
        this.newsCategories = response.list;
        if (this.newsCategories.length > 0) {
          this.selectCategory(this.newsCategories[0]);
        }
      } catch (error) {
        console.error('Error fetching news categories:', error);
      }
    },
    async fetchNewsArticles() {
      if (!this.activeCategory) return;
      try {
        const params = { category_id: this.activeCategory.id };
        const response = await getNewsArticle(params);
        this.allArticles = response.list.map(article => ({
            id: article.id,
            category: this.activeCategory.name,
            title: article.title,
            date: article.created_at,
            excerpt: article.summary,
            views: article.views_count,
            fullContent: article.content,
        }));
      } catch (error) {
        console.error('Error fetching news articles:', error);
        this.allArticles = [];
      }
    },
    
  },
  watch: {
    isModalVisible(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  mounted() {
    this.fetchNewsCategories();
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>

.article-item.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}
.article-item.clickable:hover {
  background-color: #f8f9fa;
}
.Pt75 {
  padding-top: 75px;
  padding-bottom: 75px;
  background-color: #f8f9fa;
}
.box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}
.center {
  text-align: center;
}
.PubTitle h2 {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}
.PubTitle p {
  font-size: 18px;
  color: #666;
  max-width: 800px;
  margin: 0 auto 50px;
  line-height: 1.7;
}
.news-tabs-container {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  border-bottom: 1px solid #e0e0e0;
}
.news-tabs {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 20px;
}
.news-tabs li {
  padding: 15px 25px;
  font-size: 18px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  position: relative;
  transition: color 0.3s ease;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
}
.news-tabs li:hover {
  color: #47975a;
}
.news-tabs li.active {
  color: #47975a;
  border-bottom-color: #47975a;
}
.page-container {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}
.main-content {
  flex: 1;
  min-width: 0;
}

.article-item {
  display: flex;
  gap: 25px;
  padding: 20px;
  margin-bottom: -1px;
  border: 1px solid #e9ecef;
  background-color: #fff;
}
.article-item:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.article-item:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-bottom: 0;
}
.article-date {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 25px;
  width: 90px;
  border-right: 1px solid #ebebeb;
}
.article-date .date-month {
  font-size: 26px;
  font-weight: 600;
  color: #47975a;
  line-height: 1;
}
.article-date .date-divider {
  display: block;
  width: 18px;
  height: 2px;
  background: #47975a;
  margin: 7px 0;
}
.article-date .date-year {
  font-size: 12px;
  font-weight: 500;
  color: #999;
  letter-spacing: 2px;
}
.article-content {
  flex-grow: 1;
}
.article-title {
  margin: 0 0 10px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  transition: color 0.2s;
}
.clickable:hover .article-title {
  color: #47975a;
}
.article-excerpt {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  margin: 0 0 15px 0;
}
.article-meta {
  font-size: 14px;
  color: #999;
}
.article-meta span {
  margin-right: 8px;
}
.no-articles-found {
  padding: 80px 20px;
  text-align: center;
  background: #fff;
  border-radius: 12px;
}
.no-articles-found p {
  font-size: 18px;
  color: #888;
}
.sidebar-block {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.04);
  border: 1px solid #e9ecef;
}
.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding-bottom: 15px;
  margin: -20px -20px 20px -20px;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
}
.featured-brand img, .featured-product img {
  width: 100%;
  border-radius: 6px;
  margin-bottom: 15px;
}
.featured-brand p, .featured-product h4 {
  text-align: center;
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin: 0;
}
.featured-product {
  text-align: center;
}
.featured-cases-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.featured-cases-list li {
  margin-bottom: 15px;
}
.featured-cases-list li:last-child {
  margin-bottom: 0;
}
.featured-cases-list a {
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none;
  color: #555;
  font-size: 15px;
  transition: color 0.2s;
}
.featured-cases-list a:hover {
  color: #47975a;
}
.case-thumb {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .news-tabs {
    gap: 0;
    width: 100%;
    justify-content: space-between;
  }
  .news-tabs li {
    padding: 12px 5px;
    font-size: 15px;
    flex-grow: 1;
    text-align: center;
  }
  .article-item {
    flex-direction: column;
    gap: 15px;
  }
  .article-date {
    border-right: none;
    border-bottom: 1px solid #ebebeb;
    padding-right: 0;
    padding-bottom: 15px;
    text-align: left;
    justify-content: flex-start;
  }
}
</style>
